import * as React from 'react';

import {Button} from 'shells/button/button';
import type {ButtonStyleProps} from 'shells/button/button';

import {OpenableModals, useOpenableModal} from '../../openable-modals';

type Props = {
    onClickAction?: () => void;
    buttonText?: string;
} & ButtonStyleProps;

export function EmbedAnalyticsButton(props: Props) {
    const {onOpen} = useOpenableModal(OpenableModals.EMBED_ANALYTICS_MODAL);

    return (
        <Button
            variant={props.variant || 'primary'}
            size={props.size || 'big'}
            onClick={() => {
                onOpen();

                if (props.onClickAction) {
                    props.onClickAction();
                }
            }}
        >
            {props.buttonText || 'Set up tracking'}
        </Button>
    );
}
